import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const EmissionSources = lazy(() => import('es/app/views/site/emission-sources'));
const EditEmissionSources = lazy(() => import('es/app/views/site/emission-sources/edit'));
const EditEmissionSourceForm = lazy(() => import('es/app/views/site/emission-sources/edit/EditEmissionSourceForm'));

export function EmissionSourceRoutes() {
    return (
        <Route path={siteMap.emissionSources.search()} element={<EmissionSources />} ErrorBoundary={RouteErrorBoundary}>
            {[siteMap.emissionSources.create(), siteMap.emissionSources.edit().root].map(route => (
                <Route path={route} key={route} element={<EditEmissionSources />}>
                    <Route index element={<EditEmissionSourceForm />} />
                </Route>
            ))}
        </Route>
    );
}
